import axiosClient from './axiosClient';

const classroomAttendanceApi = {
  createQrToken: (data) => {
    const url = '/classroom-attendance/qr-token';
    return axiosClient.post(url, data);
  },
  markQrAttendance: (token, data) => {
    const url = `/classroom-attendance/qr-token/${token}/mark`;
    return axiosClient.post(url, data);
  },
};

export default classroomAttendanceApi;
